import { Injectable, inject } from '@angular/core';
import { createStore, select, withProps } from '@ngneat/elf';

import { LoginSessionFacadeService } from '@digital-platform/users/services';

const activeCustomerStore = createStore(
  { name: 'activeCustomer' },
  withProps<{ customer: string }>({ customer: '' })
);

@Injectable({
  providedIn: 'root',
})
export class ActiveCustomerService {
  public selectedCustomer$ = activeCustomerStore.pipe(
    select((state) => state.customer)
  );

  private accessList: string[] = [];
  private loginSessionService = inject(LoginSessionFacadeService);

  constructor() {
    const selectedCustomer = localStorage.getItem('selectedCustomer');
    if (selectedCustomer) this.setCustomer(selectedCustomer);

    this.loginSessionService.accessList$.subscribe((accessList) => {
      this.accessList = accessList;
      if (this.accessList.length === 1) {
        this.setCustomer(this.accessList[0]);
      } else if (this.accessList.length === 0) {
        this.clearCustomer();
      }
    });
  }

  public async setCustomer(customer: string): Promise<void> {
    localStorage.setItem('selectedCustomer', customer);
    activeCustomerStore.update(() => ({ customer }));
  }

  public clearCustomer(): void {
    if (this.accessList.length !== 1) {
      activeCustomerStore.update(() => ({ customer: '' }));
      localStorage.removeItem('selectedCustomer');
    }
  }
}
